import { Modal, Input, Button, Tooltip } from "antd";

const { TextArea } = Input;

interface CreateNoteModalProps {
  isOpen: boolean;
  noteName: string;
  noteContent: string;
  isCreating: boolean;
  error: string | null;
  isNameTaken: boolean;
  onClose: () => void;
  onNameChange: (value: string) => void;
  onContentChange: (value: string) => void;
  onCreate: () => void;
}

export const CreateNoteModal = ({
  isOpen,
  noteName,
  noteContent,
  isCreating,
  error,
  isNameTaken,
  onClose,
  onNameChange,
  onContentChange,
  onCreate
}: CreateNoteModalProps) => {
  const isValid =
    noteName.trim() !== "" && noteContent.trim() !== "" && !isNameTaken;

  return (
    <Modal
      open={isOpen}
      title="Create Note"
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} style={{ color: "white" }}>
          Cancel
        </Button>,
        <Tooltip
          key="create-tooltip"
          title={
            !noteName.trim()
              ? "Please enter a note name"
              : !noteContent.trim()
                ? "Please enter note content"
                : isNameTaken
                  ? "This name is already taken"
                  : ""
          }
        >
          <Button
            key="create"
            loading={isCreating}
            disabled={!isValid}
            onClick={onCreate}
            style={{ color: !isValid ? "black" : "white" }}
          >
            Create Note
          </Button>
        </Tooltip>
      ]}
      width={600}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <label
            style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
          >
            Note Name
          </label>
          <Input
            placeholder='Enter note name (e.g., "Meeting Notes")'
            value={noteName}
            onChange={(e) => onNameChange(e.target.value)}
            status={isNameTaken ? "error" : undefined}
            suffix={
              <span style={{ color: "#999", fontSize: "12px" }}>.txt</span>
            }
          />
          {isNameTaken && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              This name is already taken. Please choose another name.
            </div>
          )}
        </div>

        <div>
          <label
            style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
          >
            Note Content
          </label>
          <TextArea
            placeholder="Enter your note content here..."
            value={noteContent}
            onChange={(e) => onContentChange(e.target.value)}
            rows={10}
            style={{ resize: "vertical" }}
          />
        </div>

        {error && !isNameTaken && (
          <div style={{ color: "red", fontSize: "14px" }}>{error}</div>
        )}

        <div style={{ fontSize: "12px", color: "#666" }}>
          <strong>Tip:</strong> Notes are saved as text files and can be used as
          sources for AI-generated content.
        </div>
      </div>
    </Modal>
  );
};
